import { render, staticRenderFns } from "./UserWant.vue?vue&type=template&id=1e909b13&scoped=true"
import script from "./UserWant.vue?vue&type=script&lang=js"
export * from "./UserWant.vue?vue&type=script&lang=js"
import style0 from "./UserWant.vue?vue&type=style&index=0&id=1e909b13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e909b13",
  null
  
)

export default component.exports